<div class="fixed transform z-1" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>

<div class="bg-default px-3 pb-3">
  <div class="flex justify-content-between align-items-center title-bg title-case" style="min-height: 50px;">
    <div class="conten clean-small" style="margin-top: -3px;">
      <div class="btn"><a>Roles Assignment</a></div>
    </div>
    <div class="flex justify-content-end mb-1 role-search">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText type="text" [(ngModel)]="filterVal"  (input)="applyFilterGlobal($event, 'contains')" placeholder="Search..." />
        <i class="pi pi-times case-keywordsearch" *ngIf="crossSearchBool"  (click)="clearSearchField()"></i>
      </span>
    </div>
  </div>

  <div class="grid flex justify-content-end mt-2">
    <div class="col-12 md:col-4 lg:col-2" *ngIf="!RoleName.toLowerCase().includes('facility')">
      <label><b>System</b></label>
      <span class="p-input-icon-right w-full">
        <p-multiSelect class="w-full" (click)="GetAllData('system')" (onChange)="GetFacility()" [options]="systemList" [style]="{'Width':'100%'}"
          [panelStyle]="{'width':'100%'}" placeholder="-- Select --" defaultLabel="--Select--" display="chip"
          [(ngModel)]="selectedSystem" optionLabel="Text" optionValue="Value" virtualScrollItemSize="43" [filter]="true"
          [virtualScroll]="true">
        </p-multiSelect>
      </span>
    </div>
    <div class="col-12 md:col-4 lg:col-2">
      <label><b>Facility</b></label>
      <span class="p-input-icon-right w-full">
        <p-multiSelect class="w-full" [options]="facilityList" [style]="{'Width':'100%'}"
          [panelStyle]="{'width':'100%'}" placeholder="-- Select --" defaultLabel="--Select--" display="chip"
          [(ngModel)]="selectedFacility" (click)="GetAllData('facility')" (onChange)="OnMultiSelectChange()" optionLabel="Text" optionValue="Value"
          virtualScrollItemSize="43" [filter]="true" [virtualScroll]="true">
        </p-multiSelect>
      </span>
    </div>
    <div class="col-12 md:col-4 lg:col-2">
      <label><b>Telecare User Type</b></label>
      <span class="p-input-icon-right w-full">
        <p-multiSelect class="w-full" [options]="rolesList" [style]="{'Width':'100%'}" [panelStyle]="{'width':'100%'}"
          placeholder="-- Select --" defaultLabel="--Select--" display="chip" [(ngModel)]="selectedUserType"
          (onChange)="OnMultiSelectChange()" optionLabel="RoleName" optionValue="RoleId" virtualScrollItemSize="43"
          [filter]="true" [virtualScroll]="true">
        </p-multiSelect>
      </span>
    </div>
  </div>
  <div class="grid justify-content-end mt-2 mb-2" id="search_btn">
    <span>
      <p-button label="Export to Excel" icon="pi pi-upload" [loading]="loading[0]" (click)="exportExcel()"
        (onClick)="load(0)" class="p-button-primary"></p-button>
    </span>
  </div>

  <p-table #dt [value]="assignedRoles" [rows]="rows" [paginator]="true" sortMode="multiple" [lazy]="true"
    (onLazyLoad)="lazyLoadSchedules($event)" responsiveLayout="scroll" [rowHover]="true" dataKey="Id"
    [totalRecords]="totalRecords" [columns]="cols" [resizableColumns]="false"
    styleClass="p-datatable-striped p-datatable-gridlines overflow-x-auto createRoles"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resetPageOnSort]="false"
    [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25,50,totalRecords]"
    [globalFilterFields]="['UserName','FirstName','LastName','Phone']" paginatorDropdownAppendTo="body">

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="UserName" pResizableColumn>User Name
          <p-sortIcon field="UserName"></p-sortIcon>
        </th>
        <th pSortableColumn="FirstName" style="min-width:15rem" pResizableColumn>First Name
          <p-sortIcon field="FirstName"></p-sortIcon>
        </th>
        <th pSortableColumn="LastName" style="min-width:15rem" pResizableColumn>Last Name
          <p-sortIcon field="LastName"></p-sortIcon>
        </th>
        <th pSortableColumn="PhoneNumber" style="min-width:15rem" pResizableColumn>Phone
          <p-sortIcon field="PhoneNumber"></p-sortIcon>
        </th>
        <th pSortableColumn="Email" style="min-width:15rem" pResizableColumn>Email
          <p-sortIcon field="Email"></p-sortIcon>
        </th>
        <th pResizableColumn>TeleCare User Type </th>
        <th pResizableColumn>Facility Role</th>
        <th *ngIf="isAccessReadWrite && !roleForFacility">Action </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-assignedRoles let-i="rowIndex">
      <tr>
        <td>
          {{assignedRoles.UserName}}
        </td>
        <td>
          {{assignedRoles.FirstName}}
        </td>
        <td>
          {{assignedRoles.LastName}}
        </td>
        <td>
          {{assignedRoles.MobilePhone}}
        </td>
        <td>
          {{assignedRoles.Email}}
        </td>
        <td>
          <span class="w-full">
            <p-multiSelect [disabled]="!isAccessReadWrite || roleForFacility" class="w-full" (onChange)="CheckChange(i)" appendTo="body"
              [options]="rolesList" [(ngModel)]="assignedRoles.RoleId" placeholder="Select User Roles" [style]="{width: '100%'}"
              defaultLabel="Select User Roles" optionLabel="RoleName" display="chip" optionValue="RoleId">
            </p-multiSelect>
          </span>
        </td>
        <td>
          <span class="w-full">
            <p-dropdown [disabled]="!isAccessReadWrite || roleForFacility" [options]="userTypeOptions" appendTo="body" [style]="{width: '100%'}"
              [(ngModel)]="assignedRoles.RoleTitle" (onChange)="onChangeReportType($event, i)" class="form-control"
              optionLabel="name" optionValue="value" placeholder="-- Select --">
            </p-dropdown>
          </span>

        </td>
        <td *ngIf="isAccessReadWrite && !roleForFacility">
          <button pButton pRipple [loading]="loading[i]"
            [style]="loading[i] == undefined || loading[i] == false ? '' : 'width:69px;'"
            (click)="GetAssignedFacilityInfo(assignedRoles, i)" class="p-button-info mr-2"
            [disabled]="IsChange[i] == undefined || IsChange[i] == true"
            [class]="loading[i] == undefined || loading[i] == false ? '' : 'w-100'">{{loading[i] == undefined || loading[i] == false ? 'Assign' : ''}}</button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <h5 *ngIf="totalRecords==0" class="text-center create-roles">
          <b> No records found</b>
        </h5>
      </tr>
    </ng-template>
  </p-table>
  <div class="md:col-12">
    <span class="tableRefreshTime ml-3">
      Grid Last Refreshed at {{PiTeamService._currentDate}} - {{PiTeamService._currentTime}}
    </span>
  </div>
</div>

<!-- Toaster to move to previous form -->
<p-toast [style]="{width: '25vw',opacity:'1'}" position="center" key="c" (onClose)="onReject()" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{message.summary}}</h4>
        <p>{{message.detail}}</p>
      </div>
      <div class="grid  justify-content-center p-fluid">
        <div>
          <button pButton type="button" label="YES"></button>
        </div>
        <div>
          <button pButton type="button" class="ml-2" (click)="onReject()" label="NO"></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<!-- Other Title Dialog Box -->

<p-dialog header="Check Assign Facility Information" [(visible)]="textAreaOtherBool" [modal]="true"
  [style]="{width: '45vw'}" [draggable]="false" [resizable]="false" (onHide)="canceltextarea($event,'Cancel')">
  <div class="fixed transform z-5" *ngIf="showProgressSpinner">
    <app-custom-spinner></app-custom-spinner>
  </div>
  <div class="facilityrole-popup">
    <h3><b>Total Assigned Facilities:</b> <span class="total-accignno mr-1 ml-1">{{totalAssignedFac}}</span></h3>
    <h3 *ngIf="showTotalAssignFacNoBool"><b>And</b> <span
        class="total-accignno mr-1 ml-1">{{totalAssignedFacNo}}</span><b>other Facilities</b></h3>
  </div>
  <div *ngIf="showAlreadyFacBool">
    <div class="mt-1" *ngIf="showAlreadyFacBool && !alreadyAssignedFacLengthBool"><b>{{roleTitleName}}</b> is already
      existed for these Facilities:</div>
    <ul *ngFor="let fac of alreadyAssignedFac">
      <li>{{fac.FacName}}</li>
    </ul>

    <div class="facility-footer col-12 md:col-12">
      <span>
        <h4 *ngIf="showTotalAssignFacBool">Do You Want to assign <b>{{roleTitleName}}</b> to all Facilities</h4>
        <h4 *ngIf="!showTotalAssignFacBool">This Facility Already Assigned. Do you want to Update.</h4>
      </span>
      <span>
        <button pButton (click)="assign()" icon="pi pi-check" type="button" class="p-button-info mx-2"
          label="Yes"></button>
        <button pButton (click)="canceltextarea($event,'Cancel');" icon="pi pi-times" type="button" class="assignfac-no"
          label="No"></button>
      </span>
    </div>
  </div>
  <div *ngIf="!showAlreadyFacBool" class="facility-footer col-12 md:col-12">
    <h4 *ngIf="!showAlreadyFacBool">This user is not linked with any facility.</h4>
    <button pButton type="button" (click)="canceltextarea($event,'Cancel')" class=" btn-UnCancelCase">
      <i class="pi pi-times"></i>&nbsp;<b>Cancel</b> </button>
  </div>
</p-dialog>
